module.exports = __webpack_public_path__ + "static/mackolik-11c550222dae2f565d5ce3ae6b93a0a7.png";